module.exports = __webpack_public_path__ + "img/nxtvector.01e3e36f.svg";